import { useLayoutEffect } from 'react';
import { BodyText, MediumHeightDivider, SmallHeightDivider, SubTitle } from '../../theme/Styles';
import { useDispatch } from 'react-redux';
import { UpdateAppSubHeaderTitle } from '../../redux/actions/UiActions';
import { Container } from './styles/GuideStyles';
import FilePDF from './Components/FilePDF/FilePDF';
import TextInformation from '../../components/TextInformation/TextInformation';
import { Fragment } from 'react';

function Guide() {

  const dispatch = useDispatch();

  useLayoutEffect(() => {
    //UPDATE APP HEADER SUBTITLE
    dispatch(UpdateAppSubHeaderTitle("Guía de Inversión en el Portal"));
  }, []);


  return (
    <Container>
      <SmallHeightDivider />
      <TextInformation title="Descripción" content={
        <BodyText>
          <strong>La Guía de Inversión de la República Dominicana </strong>
          , representa una herramienta para brindar información legal y económica sectorial del país para la promoción de la inversión extranjera, que servirá de referencia para el inversionista, y como un factor de decisión para conocer las bondades de nuestro, y elegirlo para establecer sus negocios, frente a distintos países que compiten como destino con la República Dominicana en materia de inversión. Esta Guía proporciona información valiosa sobre los atributos que hacen de nuestro país el destino de inversión líder en la región del Caribe, desglosando los principales sectores productivos y los competitivos incentivos que otorgan nuestras leyes, permitiendo al lector explorar la amplia variedad de oportunidades de inversión y posteriormente identificar las que sean de su interés
        </BodyText>
      } />
      <SmallHeightDivider />
      <TextInformation title="Archivos" content={
        <Fragment>
          <SmallHeightDivider />
          <FilePDF title="Guía de Inversión RD en Español 2022.pdf" url="https://prodominicana.gob.do/Documentos/Gu%C3%ADa%20de%20Inversi%C3%B3n%20RD%20en%20Espa%C3%B1ol%202022.pdf" />
        </Fragment>
      } />
      <MediumHeightDivider />
    </Container>
  );
}

export default Guide;
